var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileTitleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00856D",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a7.018 7.018 0 0 0-6.41 4.193 7.002 7.002 0 0 0 1.255 7.551 7.012 7.012 0 0 0 7.969 1.667 7.013 7.013 0 0 0 2.34-1.667A7.005 7.005 0 0 0 12 5zm0 12.613a5.613 5.613 0 0 1-3.892-1.577A4.205 4.205 0 0 1 12 13.43a4.21 4.21 0 0 1 3.892 2.606A5.613 5.613 0 0 1 12 17.613zm-1.403-7.007a1.4 1.4 0 0 1 1.677-1.375 1.403 1.403 0 0 1 .505 2.54 1.404 1.404 0 0 1-2.182-1.165zm6.25 4.204a5.61 5.61 0 0 0-2.743-2.368A2.802 2.802 0 0 0 12 7.785a2.807 2.807 0 0 0-2.774 3.22c.08.533.313 1.032.67 1.437a5.61 5.61 0 0 0-2.742 2.368 5.546 5.546 0 0 1-.765-2.803 5.613 5.613 0 0 1 11.221 0 5.546 5.546 0 0 1-.764 2.803z",
    fill: "#00856D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTitleIcon);
export default __webpack_public_path__ + "static/media/profileTitleIcon.44c6a4c0f985c3eb433ea21e444555aa.svg";
export { ForwardRef as ReactComponent };